/***
 * 
 * Record customer login time
 * Send the time to the customer last_login metafield
 * 
 */

// Utility Functions
function getNewZealandDateFormatted() {
  const options = {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    timeZone: 'Pacific/Auckland' // Use New Zealand time zone
  };

  const dateString = new Date().toLocaleDateString('en-CA', options); //Force YYYY-MM-DD

  const parts = dateString.split('/'); // Split the date string
  if (parts.length === 3) {
    const [day, month, year] = parts;
    return `${year}-${month}-${day}`; // Reconstruct in YYYY-MM-DD
  } else {
    return dateString; // Handle unexpected formats
  }
}

const nzDateFormatted = getNewZealandDateFormatted();
console.log("New Zealand:", nzDateFormatted);

async function sendData() {
    const loginData = {
        id: window.customerLogin.id,
        date: getNewZealandDateFormatted(),
        shop: "wstest-8869"
    }

  console.log('Sending login data', loginData)

    try {
        const response = await fetch('/apps/login_date', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(loginData)
        });

        if (!response.ok) {
            // Handle HTTP errors (status codes 400-599)
            throw new Error(`HTTP error! status: ${response.status}`);
        }

        const data = await response.json();
        console.log('Response', data);

    } catch (error) {
        console.error('Fetch Error:', error);
    }
}

// Cookie Utility Functions
function setCookie(name, value, days) {
    var expires = "";
    if (days) {
        var date = new Date();
        // Set the time to 23:59:59 of the current day for daily expiration
        date.setHours(23, 59, 59, 999);
        expires = "; expires=" + date.toUTCString();
    }
    document.cookie = name + "=" + (value || "") + expires + "; path=/";
}

function getCookie(name) {
    var nameEQ = name + "=";
    var ca = document.cookie.split(';');
    for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == ' ') c = c.substring(1, c.length);
        if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
    }
    return null;
}

// Function to check if the cookie exists and decide whether to send data
function controlSendData() {
    var cookieName = "sendDataExecuted";
    if (!getCookie(cookieName)) {
        // Cookie does not exist, execute sendData() and set the cookie
        sendData();
        setCookie(cookieName, "true", 1);
    } else {
        console.log("sendData() has already been executed today.");
    }
}

// Initialization
document.addEventListener("DOMContentLoaded", (event) => {
    // Check if window.customerLogin.id and window.customerLogin.date are defined
    if (!window.customerLogin || !window.customerLogin.id || !window.customerLogin.date) {
        console.warn('Customer is not logged in');
        return;
    }

    controlSendData(); // Only send data once per day
});